import { render, staticRenderFns } from "./ResourcesList.vue?vue&type=template&id=4354ecd1&"
import script from "./ResourcesList.vue?vue&type=script&lang=js&"
export * from "./ResourcesList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports